import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './Components/home/home.component';
import { ExamplesComponent } from './Components/examples/examples.component';
import { FeaturesComponent } from './Components/features/features.component';
import { ConsistencyChecksComponent } from './Components/features/consistency-checks/consistency-checks.component';
import { PersonalDictionaryComponent } from './Components/features/personal-dictionary/personal-dictionary.component';
import { PricingComponent } from './Components/pricing/pricing.component';
import { EnterpriseComponent } from './Components/enterprise/enterprise.component';
import { LifeSciencesMedicineAndPharmaComponent } from './Components/enterprise/life-sciences-medicine-and-pharma/life-sciences-medicine-and-pharma.component';
import { LanguageServicesPublishingAndMediaComponent } from './Components/enterprise/language-services-publishing-and-media/language-services-publishing-and-media.component';
import { AcademicInstitutionsComponent } from './Components/enterprise/academic-institutions/academic-institutions.component';
import { K12AndElearningComponent } from './Components/enterprise/k12-and-elearning/k12-and-elearning.component';
import { TechnologyPlatformsComponent } from './Components/enterprise/technology-platforms/technology-platforms.component';
import { wordpluginComponent } from './Components/word-plugin/word-plugin.component';
import { TrinkaCloudComponent } from './Components/trinka-cloud/trinka-cloud.component';
import { AboutUsComponent } from './Components/about-us/about-us.component';
import { ContactUsComponent } from './Components/contact-us/contact-us.component';
import { WorkWithUsComponent } from './Components/work-with-us/work-with-us.component';
import { PrivacyPolicyComponent } from './Components/privacy-policy/privacy-policy.component';
import { TermServicesComponent } from './Components/term-services/term-services.component';
import { PageNotFoundComponent } from './Components/page-not-found/page-not-found.component';
import { BrowserPluginComponent } from './Components/browser-plugin/browser-plugin.component';
import { AutoEditComponent } from './Components/auto-edit/auto-edit.component';
import { GcEditorComponent } from './Components/gc-editor/gc-editor.component';
import { PublicationCheckComponent } from './Components/publication-check/publication-check.component';
import { WhitePaperComponent } from './Components/white-paper/white-paper.component';
import { AffiliatesComponent } from './Components/affiliates/affiliates.component';
import { TryADemoComponent } from './Components/try-ademo/try-ademo.component';
import { ProfessionalEditingServiceComponent } from './Components/professional-editing-service/professional-editing-service.component';
import { FAQComponent } from './Components/faq/faq.component';
import { TrinkaVsGrammarlyComponent } from './Components/trinka-vs-grammarly/TrinkaVsGrammarlyComponent';
import { TrinkaVsGingerComponent } from './Components/trinka-vs-ginger/trinka-vs-ginger.component';
import { TrinkaVsLanguagetoolComponent } from './Components/trinka-vs-languagetool/trinka-vs-languagetool.component';
import { TrinkaVsWritefullComponent } from './Components/trinka-vs-writefull/trinka-vs-writefull.component';
import { CreditsComponent } from './Components/features/credits/credits.component';
import { PlagiarismCheckerComponent } from './Components/features/plagiarism-checker/plagiarism-checker.component';
import { PunctuationCheckerComponent } from './Components/punctuation-checker/punctuation-checker.component';
import { SpellCheckerComponent } from './Components/spell-checker/spell-checker.component';
import { SentenceCheckerComponent } from './Components/sentence-checker/sentence-checker.component';
import { APIComponent } from './Components/enterprise/api/api.component';
import { OnlineParaphraserComponent } from './Components/features/online-paraphraser/online-paraphraser.component';
import { LatexGrammarCheckerComponent } from './Components/features/latex-grammar-checker/latex-grammar-checker.component';
import { AiDetectorToolComponent } from './Components/ai-detector-tool/ai-detector-tool.component';
import { ParapharsingToolComponent } from './Components/parapharsing-tool/parapharsing-tool.component';
import { SogangUniversityComponent } from './Components/sogang-university/sogang-university.component';
import { YonseiUniversityComponent } from './Components/university/yonsei-university/yonsei-university.component';
import { YeungnamUniversityComponent } from './Components/university/yeungnam-university/yeungnam-university.component';
import { KonkukUniversityComponent } from './Components/university/konkuk-university/konkuk-university.component';
import { DocumarkComponent } from './Components/features/documark/documark.component';

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    data: {
      title: 'Trinka - Grammar Checker For Academic & Technical Writing',
      description: 'Trinka is the only AI grammar checker for academic & technical writing. Trinka goes beyond grammar and makes your writing publication ready with enhancements for tone, style, readability, and more!',
      keywords: 'grammar checker for academic and technical writing , advanced grammar correction, academic writing assistant, technical writing assistant, advanced grammar check, automated grammar checker, automated grammar correction, academic writing AI too'
    }
  },
  {
    path: "features",
    component: FeaturesComponent,
    data: {
      title: 'Trinka Features For Advanced Academic and Technical Writing ',
      description: 'Trinka is designed to make academic and technical writing easy and stress-free.  It enhances the tone, style, and structure of your writing to make it publication ready.',
      keywords: 'advanced grammar check, advanced spelling check, sentence correction, sentence structure checker, scientific tone, style guides'
    }
  },
  {
    path: "examples",
    component: ExamplesComponent,
    data: {
      title: 'Advanced Writing Enhancement Examples| Trinka',
      description: 'Trinka helps you make your writing fit for your audience. It checks your writing not just for grammar but for advanced writing features such as tone, style, readability, and objectivity.',
      keywords: 'advanced grammar check, grammar checker for academic writing, technical writing check, academic writing assistant, technical writing assistant'
    }
  },
  {
    path: "pricing",
    component: PricingComponent,
    data: {
      title: '',
      description: 'Trinka is the only AI grammar and language checker for academic & technical writing. Trinka goes beyond grammar and makes your writing publication ready with enhancements for tone, style, readability, and more!',
      keywords: 'grammar checker for academic and technical writing , advanced grammar correction, academic writing assistant, technical writing assistant, advanced grammar check, automated grammar checker, automated grammar correction, academic writing AI too'
    }
  },
  {
    path: "enterprise",
    component: EnterpriseComponent,
    data: {
      title: 'Trinka For Enterprise | Advanced Grammar Checker For Your Team',
      description: " 'Trinka - the only writing assistant you'll need for your team. Best suited for Academic Institutions, Language Service Providers, Publishers, and Businesses working with content. Contact today for attractive pricing.' ",
      keywords: 'grammar checker , grammar correction, automated grammar check, automatic spelling correction, Academic writing assistant for institutions, academic writing assistant for publishers, academic writing assistant for language service providers'
    }
  },
  {
    path: "wordplugin",
    component: wordpluginComponent,
    data: {
      title: 'Download Trinka Plugin For Microsoft Word | Free Grammar Checker',
      description: 'The Trinka plug-in for Word makes effective writing easier than ever! It auto-checks your writing and changes as you write within your familiar Word app. Download Trinka for Free Now!',
      keywords: 'advanced grammar check, spell checker, free grammar check, academic writing assistant'
    }
  },
  {
    path: "trinkacloud",
    component: TrinkaCloudComponent,
    data: {
      title: 'Trinka Cloud | Easy writing On The Go',
      description: 'Effective writing on the go with Trinka Cloud. With real-time corrections as you write, Trinka is always with you. Get the best writing advice anytime and anywhere you write!',
      keywords: 'Grammar checker App, contextual spelling correction, Academic Writing App, technical writing app, grammar correction tool, automated grammar checker, English writing tool'
    }
  },
  {
    path: "aboutus",
    component: AboutUsComponent,
    data: {
      description: 'Trinka is the only AI grammar and language checker for academic & technical writing. Trinka goes beyond grammar and makes your writing publication ready with enhancements for tone, style, readability, and more!',
      keywords: 'grammar checker for academic and technical writing , advanced grammar correction, academic writing assistant, technical writing assistant, advanced grammar check, automated grammar checker, automated grammar correction, academic writing AI too'
    }
  },
  {
    path: "contactus",
    component: ContactUsComponent,
    data: {
      description: 'Trinka is the only AI grammar and language checker for academic & technical writing. Trinka goes beyond grammar and makes your writing publication ready with enhancements for tone, style, readability, and more!',
      keywords: 'grammar checker for academic and technical writing , advanced grammar correction, academic writing assistant, technical writing assistant, advanced grammar check, automated grammar checker, automated grammar correction, academic writing AI too'
    }
  },
  {
    path: "workwithus",
    component: WorkWithUsComponent,
    data: {
      description: 'Trinka is the only AI grammar and language checker for academic & technical writing. Trinka goes beyond grammar and makes your writing publication ready with enhancements for tone, style, readability, and more!',
      keywords: 'grammar checker for academic and technical writing , advanced grammar correction, academic writing assistant, technical writing assistant, advanced grammar check, automated grammar checker, automated grammar correction, academic writing AI too'
    }
  },
  {
    path: "privacypolicy",
    component: PrivacyPolicyComponent,
    data: {
      description: 'Trinka is the only AI grammar and language checker for academic & technical writing. Trinka goes beyond grammar and makes your writing publication ready with enhancements for tone, style, readability, and more!',
      keywords: 'grammar checker for academic and technical writing , advanced grammar correction, academic writing assistant, technical writing assistant, advanced grammar check, automated grammar checker, automated grammar correction, academic writing AI too'
    }
  },
  {
    path: "termsofservices",
    component: TermServicesComponent,
    data: {
      description: 'Trinka is the only AI grammar and language checker for academic & technical writing. Trinka goes beyond grammar and makes your writing publication ready with enhancements for tone, style, readability, and more!',
      keywords: 'grammar checker for academic and technical writing , advanced grammar correction, academic writing assistant, technical writing assistant, advanced grammar check, automated grammar checker, automated grammar correction, academic writing AI too'
    }
  },
  {
    path: "browser-plugin",
    component: BrowserPluginComponent,
  },
  {
    path: "auto-edit",
    component: AutoEditComponent,
  },
  {
    path: "grammar-checker",
    component: GcEditorComponent,
  },
  {
    path: "trinka-vs-grammarly-vs-language-tool",
    component: WhitePaperComponent,
  },
  {
    path: "affiliates",
    component: AffiliatesComponent,
  },
  {
    path: "faqs",
    component: FAQComponent,
  },
  {
    path: "professional-editing-service",
    component: ProfessionalEditingServiceComponent,
  },
  { path: "trinka-vs-grammarly", component: TrinkaVsGrammarlyComponent },
  { path: "trinka-vs-ginger", component: TrinkaVsGingerComponent },
  { path: "trinka-vs-languagetool", component: TrinkaVsLanguagetoolComponent },
  { path: "trinka-vs-writefull", component: TrinkaVsWritefullComponent },
  { path: "grammar-checker", component: GcEditorComponent },
  { path: "enterprise", component: EnterpriseComponent },
  { path: "enterprise/life-sciences-medicine-and-pharma", component: LifeSciencesMedicineAndPharmaComponent },
  { path: "enterprise/language-services-publishing-and-media", component: LanguageServicesPublishingAndMediaComponent },
  { path: "enterprise/academic-institutions", component: AcademicInstitutionsComponent },
  { path: "enterprise/k12-and-elearning", component: K12AndElearningComponent },
  { path: "enterprise/technology-platforms", component: TechnologyPlatformsComponent },
  { path: "features/consistency-check", component: ConsistencyChecksComponent },
  { path: "features/personal-dictionary", component: PersonalDictionaryComponent },
  { path: "features/publication-readiness-checks", component: PublicationCheckComponent },
  { path: "features/auto-file-edit", component: AutoEditComponent },
  { path: "features/credits", component: CreditsComponent },
  { path: "features/plagiarism-check", component: PlagiarismCheckerComponent },
  { path: "features/documark", component: DocumarkComponent },
  { path: "punctuation-checker", component: PunctuationCheckerComponent },
  { path: "spell-checker", component: SpellCheckerComponent },
  { path: "sentence-checker", component: SentenceCheckerComponent },
  { path: "enterprise/grammar-checker-api", component: APIComponent },
  { path: "features/paraphraser", component: OnlineParaphraserComponent },
  { path: "features/latex-grammar-checker", component: LatexGrammarCheckerComponent },
  { path: "ai-content-detector", component: AiDetectorToolComponent },
  { path: "paraphrasing-tool", component: ParapharsingToolComponent },
  { path: "sogang-university", component: SogangUniversityComponent },
  { path: "university/yonsei-university", component: YonseiUniversityComponent },
  { path: "university/yeungnam-university", component: YeungnamUniversityComponent },
  { path: "university/konkuk-university", component: KonkukUniversityComponent },
  { path: "news",  loadChildren: () => import('./modules/news/news.module').then(m => m.NewsModule)},
  {
    path: '**',
    component: PageNotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
